import React from 'react';

const PerformanceTabContext = React.createContext();

export default PerformanceTabContext;
